
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ilein", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $d5a546ec940780a1$export$6503ec6e8aabbaf; }, function (v) { return $d5a546ec940780a1$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $d5a546ec940780a1$export$f7ad0328861e2f03; }, function (v) { return $d5a546ec940780a1$export$f7ad0328861e2f03 = v; });
var $d5a546ec940780a1$export$6503ec6e8aabbaf;
var $d5a546ec940780a1$export$f7ad0328861e2f03;
"use strict";
var $d5a546ec940780a1$var$mapping = new Map();
function $d5a546ec940780a1$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$d5a546ec940780a1$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $d5a546ec940780a1$var$resolve(id) {
    var resolved = $d5a546ec940780a1$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$d5a546ec940780a1$export$6503ec6e8aabbaf = $d5a546ec940780a1$var$register;
$d5a546ec940780a1$export$f7ad0328861e2f03 = $d5a546ec940780a1$var$resolve;

});

var $12b20f096096b051$exports = {};

(parcelRequire("ilein")).register(new URL("", import.meta.url).toString(), JSON.parse('["9fHBb","index.9849fff2.js","5a1aL","Grocery.223d53be.js"]'));


//# sourceMappingURL=index.runtime.4c51aff7.js.map
